import { render, staticRenderFns } from "./FooterWrap.vue?vue&type=template&id=34ad24e6&scoped=true&"
import script from "./FooterWrap.vue?vue&type=script&lang=js&"
export * from "./FooterWrap.vue?vue&type=script&lang=js&"
import style0 from "./FooterWrap.vue?vue&type=style&index=0&id=34ad24e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ad24e6",
  null
  
)

export default component.exports